import Vue from "vue";
const templateId = document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/allrazdel.js";

let component = Vue.component("allrazdel", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['posts','jsonval'],
      data() {
        return {
          orderName: []
        }
      },
      mounted() {
        if (this.posts) {
          for (let x = 0; x < this.posts.length; x++) {
            this.orderName.push({"name": this.posts[x].name, "id": this.posts[x].id})
          }
        }
      },
      methods: {
        hideAllRazdel(index) {
          this.$emit('putHideRazdelToApp', index)
        },
        hideDefault() {
          this.$emit('putHideRazdelToApp', -1)
          this.$emit('putHideDefault')
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/allrazdel.js